<template>
      <div :style="'background-color:' + $bgColor +' ; height: 80px;'">
          <!-- <v-row style="margin-bottom: 10px;">
            <div :style="'z-index: 0;font-size: 20px;font-weight: bold;position: relative;height:95px;color#fff;padding:15px;color:white;background-image: linear-gradient(0deg,' + $bgColor + '0%,' + $bgColor2 + '100%);'" fixed dense >
            <div :style="'height: 103px;background-color:' + $bgColor2 + ';width: 103px;border-radius: 100px;position: absolute;z-index: -1;right: 60px;top: -52px;'"></div>
            <div :style="'height: 89px;background-color:' + $bgColor3 + ';width: 89px;border-radius: 100px;position: absolute;z-index: -1;right: 0px;top: 2px;'"></div>
            <div :style="'height: 52px;background-color:' + $bgColor3 + ';width: 52px;border-radius: 100px;position: absolute;z-index: -1;right: 0px;top: 2px;'"></div>
            กิจกรรม
          </div>
          </v-row> -->
          <div :style="'z-index: 0;font-size: 20px;font-weight: bold;position: relative;height:95px;color#fff;padding:15px;color:white;background-image: linear-gradient(0deg,' + $bgColor + '0%,' + $bgColor2 + '100%);'" fixed dense >
            <div :style="'height: 103px;background-color:' + $bgColor2 + ';width: 103px;border-radius: 100px;position: absolute;z-index: -1;right: 60px;top: -52px;'"></div>
            <div :style="'height: 89px;background-color:' + $bgColor3 + ';width: 89px;border-radius: 100px;position: absolute;z-index: -1;right: 0px;top: 2px;'"></div>
            <div :style="'height: 52px;background-color:' + $bgColor3 + ';width: 52px;border-radius: 100px;position: absolute;z-index: -1;right: 0px;top: 2px;'"></div>
            <p class="mb-0" :style="'color:' + $textcolor">{{ $t("message.allLevel") }}</p>
          </div>
          <div>
            <div style="height: 100vh;">
                <v-tabs
                  v-model="tab"
                  :background-color="$bgColor"
                  dark
                  show-arrows
                >
                  <v-tab v-for="(item, index) in level" :key="index" :href="'#tab-' + index" :style="'color:' + $textcolor">
                    {{item.name}}
                  </v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                  <v-tab-item
                    v-for="(item, index) in level"
                    :key="index"
                    :value="'tab-' + index"
                  >
                    <v-card flat>
                      <v-card-text>
                         <v-container class="pa-6">
                           <h4>{{item.name}}</h4>
                              <v-row>
                                  <v-col class="headline1 font16 bold">{{ $t("message.privilegeDetail") }}</v-col>
                              </v-row>
                              <v-row>
                                  <v-col dark><nl2br tag="p" :text="$i18n.locale === 'th' ? item.priviledge || '' : item.priviledgeEng || ''"></nl2br></v-col>
                              </v-row>
                          </v-container>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </div>
          </div>
        </div>
</template>
<script>
import MenuItem from '../MenuItem'
import { mapGetters } from 'vuex'

export default {
  components: {
    'menu-item': MenuItem
  },
  data () {
    return {
      level: null,
      tab: null,
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted () {
    // this.getLevelDB()
    this.level = this.GET_LEVEL()
  },
  methods: {
    ...mapGetters('shopStore', ['GET_LEVEL'])
    // async getLevelDB () {
    //   console.log('เข้าจ่ะ')
    //   const result = await this.callBeTaskAPI('get', '/level/line/get?RECORD_STATUS=N')
    //   console.log('eoeoeoeoe', result)
    //   if (result) {
    //     if (result.length > 0) {
    //       this.level = result.sort((a, b) => {
    //         if (a.point < b.point) { return -1 } else if (a.point > b.point) { return 1 } else { return 0 }
    //       })
    //       console.log('eoeoeoeoe', this.level)
    //     }
    //   }
    // }
  }
}
</script>
<style scoped>
p{
  margin-bottom: 0;
  margin: auto;
  color: black;
}
a.v-tab {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Card/TierBenefit.vue